import React, { useCallback, useEffect, useState, useMemo } from "react";
import styled, { withTheme } from "styled-components";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { toAlpha } from "../../../modules/utils";
import Checkbox from "../../ui-library/Checkbox/Checkbox";
import AlertUGNX from "../../ToastsAndAlerts/AlertUGNX";
import { AlertType } from "../../ToastsAndAlerts/constants";

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const StyledCheckboxContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;

  span {
    font-weight: 500;
  }
`;

const AddCaregiver = (props) => {
  const {
    onSubmit,
    caregivers,
    participant,
    hasError,
    alertMessage = "",
    setAlertMessage,
  } = props;

  const [submitting, setSubmitting] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);

  const nextUsername = useMemo(
    () =>
      `${participant.userName}-${toAlpha(
        (caregivers?.length || 0) + 1
      ).toUpperCase()}`,
    [participant, caregivers]
  );

  useEffect(() => {
    const participantCaregiver = caregivers?.find(
      (caregiver) => caregiver.relationshipType
    );

    if (participantCaregiver) {
      setAlertMessage(
        `Participant already assigned to ${participantCaregiver.ugnxId}`
      );
    }
  }, [caregivers]);

  useEffect(() => {
    if (hasError) {
      setSubmitting(false);
    }
  }, [hasError]);

  const submitForm = useCallback(() => {
    const formData = {
      ugnxId: nextUsername,
      participantId: participant.participantId,
      relationshipType: isParticipant,
    };

    setSubmitting(true);
    onSubmit(formData);
  }, [nextUsername, onSubmit, isParticipant]);

  return (
    <FormContainer data-testid="add-new-caregiver-form">
      <LabelledInput
        data-testid="username-input"
        className="mb-4"
        title="Caregiver ID"
        value={nextUsername}
        type="text"
        readOnly={true}
      />

      <StyledCheckboxContainer className="mb-4">
        <Checkbox
          data-testid="checkbox"
          checked={isParticipant}
          onClick={() => setIsParticipant((prevValue) => !prevValue)}
          icon={true}
          square={true}
        />
        <span data-testid="checkbox-label">Participant</span>
      </StyledCheckboxContainer>

      {alertMessage && (
        <AlertUGNX type={AlertType.WARNING}>{alertMessage}</AlertUGNX>
      )}

      <StyledFooter>
        <PrimaryButton
          disabled={submitting || (alertMessage !== "" && isParticipant)}
          data-testid="add-caregiver"
          onClick={submitForm}
        >
          Add caregiver
        </PrimaryButton>
      </StyledFooter>
    </FormContainer>
  );
};

export default withTheme(AddCaregiver);
